import { Injectable } from '@angular/core';

import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MapEventsService {

  private onVehicleClickedSubject = new Subject<number>();
  get vehicleClicked(): Observable<number> {
    return this.onVehicleClickedSubject;
  }

  constructor() { }

  emmitVehicleClicked(vehicleId: number) {
    this.onVehicleClickedSubject.next(vehicleId);
  }
}
